import { TableDefine } from '@/libs/tableHelper/type'
import { Spouse } from '@/api/spouse/Spouse'

// 数据表格的列定义
export default function getTableDefine (view: any): TableDefine<Spouse> {
  const tableCols = [{
    title: '图片',
    type: {
      module: 'imageUrl',
      borderRadius: 0,
      width: 120
    },
    key: 'picture'
  }, {
    title: '姓名',
    key: 'name'
  }, {
    title: '是否离异',
    type: {
      module: 'enum',
      enum: 'base/boolean'
    },
    key: 'isDivorce'
  }, {
    title: '是否丧偶',
    type: {
      module: 'enum',
      enum: 'base/boolean'
    },
    key: 'isBereave'
  }, {
    title: '修改时间',
    type: {
      module: 'time',
      format: 'yyyy-MM-DD'
    },
    key: 'updateTime'
  }, {
    title: '创建时间',
    type: {
      module: 'time',
      format: 'yyyy-MM-DD'
    },
    key: 'createTime'
  }]

  const actions: any = [{
    name: 'view',
    title: '详情',
    onClick: (dataItem: Spouse) => {
      view.onViewItem(dataItem)
    }
  }, {
    name: 'modi',
    title: '编辑',
    onClick: (dataItem: Spouse) => {
      view.onEditItem(dataItem)
    }
  }]

  return {
    tableCols,
    actions
  }
}
